module.exports = __webpack_public_path__ + "img/jpg.4d931864.svg";